<div class="report row">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">User ID:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userId }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">User Name:</span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4" *ngIf="itm.userPhone1">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Phone No.1:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userPhone1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4" *ngIf="itm.userPhone2">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Phone No.2:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userPhone2 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Date Of Birth:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userDateOfBirth }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">ID Type:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userIdType }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">ID Number:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userIdNumber }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Home Details:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userHomeAreaDetails }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4" *ngIf="itm.userEmail1">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">Email 1:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userEmail1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4" *ngIf="itm.userEmail2">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">Email 2:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userEmail1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Location:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.locationName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 d-flex justify-content-start">
        <span class="">Recruitment Date:</span>
      </div>
      <div class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userRecruitmentDate }}
        </span>
      </div>
    </div>
  </div>
</div>